import axios from "axios"
import { API_BASE_URL, APIs } from "../constants/Constants"

export const refreshToken = async() => {
    try {
        const machineId = localStorage.getItem("machineid");
        const response = await axios.post(API_BASE_URL + APIs.REFRESHTOKEN,{},{
                headers: {
                    "X-machineId": machineId, // Manually attach the machine ID
                    "Content-Type": "application/json"
                
            }
            
        })
        return response; 
    } catch (error) {
        return error.response;
    }
}